import React from 'react'
import { checkTranslation, checkVariablesListForValue, getObject, priceStandardView, textVariableReplacer, translate } from '../../utils/useful';
import TableViewer from '../TableViewer';
import HelpButton from '../HelpButton';
import Responsive from '../Responsive';

class InvoiceWidget extends React.Component {

  state = {

    invoiceHeaders: [
      { key: 'product', type: 'ProductSelectInput', col: '4', information: { label: '{{lang}}Item', address: 'ygetProducts', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', image: 'images', value: '_id', price: 'price', unit: 'unit' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: true },
      { key: 'count', type: 'NumberInput', col: '3', information: { label: '{{lang}}Quantity', placeholder: '{{lang}}useful.count', required: true } },
      { key: 'amounts.base', type: 'PriceInput', col: '2', information: { label: '{{lang}}Rate', placeholder: '{{lang}}useful.rate', required: true } },
      { key: 'amounts.final', type: 'PriceInput', col: '3', information: { label: '{{lang}}Amount', disabled: true, placeholder: '{{lang}}useful.amount', required: true } },

    ],
    items: [],
  }


  componentDidMount() {

    this.init()


  }


  init = () => {


    let information = this.props.header?.information

    // console.log(this.props.data)
    // console.log(this.props.header?.information)

    // return

    this.setState({ rawData: information.source })
    // console.log("this.init")
    // console.log(this.props.fullData)
    // console.log(this.props.headers)

    // console.log(this.props.data?.content)
    // console.log('this.props.data?.contentl',this.props.data?.content)
    let data = information.source
    let items = []
    let amounts = {}
    // console.log(data)
    // console.log(this.props.params)
    if (data) {

      if (/\{\{(.*?)\}\}/.test(String(data))) {

        let baseValue = String(data).replace(/{/g, '').replace(/}/g, '')
        let amountBaseValue = baseValue.split(' - ')
        amountBaseValue[amountBaseValue.length - 1] = 'Amounts'
        amountBaseValue = amountBaseValue.join(' - ')
        // console.log(baseValue)
        // console.log(amountBaseValue)

        data = checkVariablesListForValue(this.props.params, baseValue, ' - ')?.data
        // amounts = checkVariablesListForValue(this.props.params, amountBaseValue, ' - ')?.data
        // amounts = checkVariablesListForValue(this.props.params, amountBaseValue, ' - ')?.data
        if (Array.isArray(this.props.params)) {

          for (let index = 0; index < this.props.params.length; index++) {
            const param = this.props.params[index];
            if (baseValue.split(' - ')[0] == param?.label) {
              amounts = getObject(param.info, 'amounts')
            }
          }

        }

        // console.log(amounts)

        if (Array.isArray(data)) {
          for (let i = 0; i < data.length; i++) {
            const element = data[i];
            if (element.product) {
              items.push(element)
            }

          }
        }

      }

      // console.log(items)
      // console.log(amounts)

      // data = this.textVariableReplacer(this.props.fullData, data, this.props.headers, 'Current Record')

      // if (Array.isArray(this.props.params)) {
      //   for (let i = 0; i < this.props.params.length; i++) {
      //     const param = this.props.params[i];
      //     data = this.textVariableReplacer(param?.info, data, param?.fields, param?.label)
      //   }
      // }


      this.setState({ items: null, amounts: null }, () => {
        this.setState({ items, amounts })

      })
    } else {


      this.setState({ items: data })
    }


  }






  render() {


    // let information = this.props.header?.information
    // console.log(information)
    let amounts = this.state.amounts
    let taxInfo

    let currency = this.props.variables?.appletSettings?.currency ?? '$'
    let toFix = this.props.variables?.appletSettings?.decimalPlaces ?? 2

    // console.log(currency)
    // console.log(amounts)

    return (

      <div className="" style={{ minHeight: 5, }}>


        <div className="mt-3">
          <TableViewer headers={this.state.invoiceHeaders} data={this.state.items} top={0} actions={null} />
        </div>


        {/* <div className="d-flex px-3 mt-3">
          <div className="text-center w-100">
            <p className="text-small text-start mb-2">{translate("Subtotal")}</p>
            <p className="text-small text-start mb-2">{translate("Discount")}</p>
            <p className="text-small text-start mb-2">{translate("Tax")}</p>
            <p className="text-small text-start mb-2">{translate("Shipping")}</p>
            {this.state.invoice?.list?.adjustment != null && this.state.invoice?.list?.adjustment != '' && this.state.invoice?.list?.adjustment != 0 && (
              <p className="text-small text-start mb-2">{checkTranslation(this.state.invoice?.list?.adjustmentTitle) ?? translate("Adjustment")}</p>
            )}
            <p className="text-small text-start mb-2  text-bold">{translate("Total")}</p>
            <p className="text-small text-start mb-2" style={{ color: '#ee5050' }}>{translate("Payments made")}</p>
            <p className="text-small text-start mb-2" style={{ borderTop: '1px solid #eee', padding: '5px 0px' }}>{translate("Balance due")}</p>



          </div>

          <div className="text-center w-100">
            <p className="text-small text-start mb-2">{priceStandardView(amounts?.items?.base)}</p>
            <p className="text-small text-start mb-2">{priceStandardView(amounts?.totals?.discount)}</p>
            <p className="text-small text-start mb-2">{priceStandardView(amounts?.totals?.tax)}</p>
            <p className="text-small text-start mb-2">{priceStandardView(amounts?.totals?.shipping)}</p>
            {amounts?.totals?.adjustment != null && amounts?.totals?.adjustment != '' && amounts?.totals?.adjustment != 0 && (
              <p className="text-small text-start mb-2">{priceStandardView(amounts?.totals?.adjustment)}</p>
            )}
            <p className="text-small text-start mb-2 text-bold">{priceStandardView(amounts?.totals?.final)}</p>
            <p className="text-small text-start mb-2" style={{ color: '#ee5050' }}>(-) {priceStandardView(Number(amounts?.totals?.total) - (Number(this.state.invoice?.balanceDue) ?? 0))}</p>
            <p className="text-small text-start mb-2" style={{ borderTop: '1px solid #eee', padding: '5px 0px' }}>{priceStandardView(this.state.invoice?.balanceDue)}</p>


          </div>
        </div> */}
        <div className='flexc flex-wrap w-100'>

          <Responsive width={this.props.width} media={{ xs: '12', sm: '6', md: '6', lg: '6', xl: '9' }}>

          </Responsive>

          <Responsive width={this.props.width} media={{ xs: '12', sm: '6', md: '6', lg: '6', xl: '3' }}>


            <div className='pb-1 mt-3' style={{ borderBottom: '1px solid #eee' }}>

              <div className='flexcb pb-2'>
                <p className='font-size-14 w-100 weight-500' style={{ color: '#000' }}>{translate("Subtotal")}</p>
                <p className='font-size-14 weight-500' style={{ color: '#000' }}>{currency}{priceStandardView(Number(amounts?.items?.base).toFixed(toFix))}</p>
              </div>

              {amounts?.totals?.discount > 0 && (
                <div className='flexcb pb-2'>
                  <p className='font-size-14 w-100 weight-500' style={{ color: 'rgb(204, 12, 57)' }}>{translate("Discount")}</p>
                  <p className='font-size-14 weight-500' style={{ color: 'rgb(204, 12, 57)' }}>{currency}-{priceStandardView(Number(amounts?.totals?.discount ?? 0).toFixed(toFix))}</p>
                </div>
              )}



              {amounts?.adjustments && amounts.adjustments.map((adjustment, i) => {
                if (adjustment.after == 'discount') {
                  return (
                    <div className='flexcb pb-2 position-relative' key={adjustment.id}>

                      <p className='font-size-14 w-100 weight-500' style={{ color: adjustment.amount < 0 ? 'rgb(204, 12, 57)' : null }}>{checkTranslation(adjustment.title)}</p>

                      <p className='font-size-14 weight-500' style={{ color: adjustment.amount < 0 ? 'rgb(204, 12, 57)' : null }}>{adjustment.mode == "discount" ? "-" : ''}{currency}{priceStandardView(Number(adjustment.amount).toFixed(toFix))}</p>

                    </div>
                  )
                }
              })}

            </div>
            {taxInfo?.taxes != null && amounts?.totals?.taxable != null && (


              <div className='mt-2 pt-2 pb-2' style={{ borderBottom: '1px solid #eee' }}>


                <div className='flexcb pb-2'>
                  <p className='font-size-14 weight-500 '>{translate('Total before tax')}</p>
                  <p className='font-size-14 weight-500 '>{currency}{priceStandardView(Number(amounts?.totals?.beforeTax ?? 0).toFixed(toFix))}</p>
                </div>

                {taxInfo?.taxes != null && amounts?.totals?.taxable != null && (
                  <div className='flexcb pb-2'>
                    <p className='font-size-14 weight-500 '>{translate('Total taxable')}</p>
                    <p className='font-size-14 weight-500 '>{currency}{priceStandardView(Number(amounts?.totals?.taxable).toFixed(toFix))}</p>
                  </div>
                )}

                {/* {taxInfo?.taxes == null && (
                <div className='flexcb pb-2'>
                  <p className='font-size-14 weight-500 '>{translate('Tax')}</p>
                  <p className='font-size-14 weight-500 '>{currency}0</p>
                </div>
              )} */}



                {Array.isArray(taxInfo?.taxes) && taxInfo?.taxes.length > 0 && (
                  <div className='mb-1'>
                    {taxInfo?.taxes?.map((item, index) => {
                      // if (this.state.taxAmounts && this.state.taxAmounts[tax._id]) {
                      return (
                        <div className='pb-1'>
                          <div className='' key={item._id}>
                            <div className='flexcb' >
                              <div className='flexc'>
                                <p className='font-size-14 weight-500 flexc '>{checkTranslation(item.tax?.name)}</p>
                                {item.tax?.description && (
                                  <HelpButton data={item.tax?.description} />
                                )}
                              </div>

                              <p className='font-size-14 weight-500 '>{priceStandardView(Number(item.amount).toFixed(toFix))}{currency}</p>
                            </div>
                            <p className='text-smallest opacity-7'><span className='text-smallest mld-1'>{currency}{item?.rate}</span> {`* ${item.taxable}${currency}`}</p>

                          </div>
                        </div>
                      )
                      // }
                    })}
                  </div>
                )}


              </div>
            )}


            <div className='py-3 flexcb' >
              <p className='font-size-16 weight-600 '>{translate('General total')}</p>
              <p className='font-size-16 weight-600 '>{currency}{priceStandardView(Number(amounts?.totals?.final).toFixed(toFix))}</p>
            </div>

          </Responsive>

        </div>
      </div>


    )
  }
}

export default InvoiceWidget;